module.exports = __webpack_public_path__ + "img/Fee Collection.3f31359c.svg";